import React from 'react';
import './styles/SignUp.css';
import google_icon from '../assets/images/google-icon.png';
import { useNavigate } from 'react-router-dom';
const SignUp = () => {
     const navigate = useNavigate();

  const getLocationScreen = () => {
    navigate('/locationscreen'); // Navigates to SignUp screen
  };
  return (
    <div className="signup-container">
      <div className="signup-box">
        <h2 className="signup-title">Sign Up</h2>
        <div className="underline"></div>

        <input type="text" placeholder="User Name" className="signup-input" />
        <input type="email" placeholder="E-Mail" className="signup-input" />
        <input type="tel" placeholder="Mobile No." className="signup-input" />

        <button className="otp-button">Generate OTP</button>

        <input type="text" placeholder="Enter OTP" className="signup-input" />

        <label className="checkbox-label">
          <input type="checkbox" />
          <span>YES, I Agree with <a href="/">terms</a> and <a href="/">policy</a></span>
        </label>

        <button className="signup-btn" onClick={getLocationScreen}>SIGN UP</button>

        <p className="have-account">
          <a href="/">I Have An Account</a>
        </p>

        <div className="divider">
          <span>OR</span>
        </div>

        <button className="google-btn">
          <img src={google_icon} alt="Google" />
          Continue With Google
        </button>
      </div>
    </div>
  );
};

export default SignUp;
